import React, { useState } from 'react';
import {
  Button,
  Box,
  Container,
  TextField,
} from '@material-ui/core';




export const ReportBugs = () => {

  
  const [html, setHtml] = useState('');
  const pasteValueExtract = (e) => {
    const htmlText = e.clipboardData.getData('text/html');
    setHtml(htmlText);
  };
  const downloadTxtFile = () => {
    const element = document.createElement('a');
    const file = new Blob([html], {
      type: 'text/plain;charset=utf-8',
    });
    element.href = URL.createObjectURL(file);
    element.download = 'bug.html';
    document.body.appendChild(element);
    element.click();
  };

  return (
    <>
  
      <Container fullWidth>
        <Box mt={2} fullWidth>
          <TextField
            style={{ width: '100%' }}
            placeholder="Paste here"
            variant="outlined"
            label="Bug Report"
            onPaste={(e) => pasteValueExtract(e)}
            autoFocus
            fullWidth
          ></TextField>
        </Box>
        
        {html !== '' && (
          <Button color="primary" variant="contained" onClick={downloadTxtFile}>
            Download i
          </Button>
        )}
      </Container>
    </>
  );
};


export default ReportBugs;